
import state from './sendkakaoState.js'
import mutations from './sendkakaoMutaions.js'
import actions from './sendkakaoAction.js'
import getters from './sendkakaoGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

